import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// This hook controls whether to show ageing column, axis, and filter in reports
// based on configuration settings.
// CYCLE_TIME_CALCULATION_ALGORITHM_NOTE: This is temporary toggle, will be removed after BE supports ageing for cycle time calculation algorithm
export const useIsExcludingWeekendAndHolidays = () => {
  const { data: config } = useInstanceConfigQuery();
  const algorithm =
    config?.feature_toggles?.["CYCLE_TIME_CALCULATION_ALGORITHM"] ?? "basic";

  return algorithm === "excluding_weekend_and_holidays";
};
